// extracted by mini-css-extract-plugin
export default {"iconsRow":"style_iconsRow__-sEV9"};